var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "company-switcher__trigger",
      class: { "is-open": _vm.open },
      attrs: {
        type: "button",
        "aria-haspopup": "listbox",
        "aria-expanded": _vm.open ? "true" : "false",
        "aria-controls": _vm.open ? _vm.panelId : null,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("toggle")
        },
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            )
              return null
            $event.preventDefault()
            return _vm.$emit("open")
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            )
              return null
            $event.preventDefault()
            return _vm.$emit("open")
          },
        ],
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "company-switcher__trigger-icon",
          attrs: { "aria-hidden": "true" },
        },
        [_c("lucide-icon", { attrs: { icon: _vm.icons.building, size: 16 } })],
        1
      ),
      _c("span", { staticClass: "company-switcher__trigger-text" }, [
        _c("span", { staticClass: "company-switcher__trigger-label" }, [
          _vm._v(_vm._s(_vm.$t("empresa"))),
        ]),
        _c("span", { staticClass: "company-switcher__trigger-value" }, [
          _vm._v(_vm._s(_vm.label || _vm.$t("selecioneempresa"))),
        ]),
      ]),
      _c("lucide-icon", {
        staticClass: "company-switcher__trigger-chevron",
        attrs: {
          icon: _vm.icons.chevronsUpDown,
          size: 16,
          "aria-hidden": "true",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }